/**
 * filterApplied - is a custom SVG Icon that displays when a filter is applied to a Grid column.
 */
import * as React from 'react';
import { createSvgIcon } from '@mui/material';

export const FilterApplied = createSvgIcon(
  <path
    d={
      'm11 12.75v2h-4v-2h4zm-1.2975-5.0002c0.666 0.952 1.644 1.654 2.78 2h-9.483v-2zm4.2973-7.7496c2.619 0 4.75 2.131 4.75 4.75s-2.131' +
      ' 4.75-4.75 4.75-4.75-2.131-4.75-4.75 2.131-4.75 4.75-4.75zm-4.8496 2.7496c-0.255 0.617-0.4 1.292-0.4 2h-8.75v-2z'
    }
    transform="translate(3.5, 3.5)"
  />,
  'FilterApplied'
);
